<template>
  <div class="storagePayDetail">
    <el-form class="form" label-width="auto">
      <el-form-item>
        <h1 style="margin-right: 20px;">{{ data.storagePay.id ? '编辑' : '新增' }}仓储付款信息</h1>
        <el-button-group>
          <el-button @click="router.go(-1)">返回</el-button>
          <el-button type="primary" @click="add()" v-if="data.storagePay.id == null">保存</el-button>
          <el-button type="primary" @click="payment()" v-if="data.storagePay.id != null && data.storagePay.reviewState == 'pass'">保存</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item label="审核状态" v-if="data.storagePay.id != null">
        <el-text v-if="data.storagePay.reviewState == 'none'">未审核</el-text>
        <el-text type="success" v-if="data.storagePay.reviewState == 'pass'">通过</el-text>
        <el-text type="danger" v-if="data.storagePay.reviewState == 'unpass'">不通过</el-text>
      </el-form-item>
      <el-form-item label="审核备注" v-if="data.storagePay.id != null && data.storagePay.reviewState != 'none'">
        <el-text>{{ data.storagePay.reviewNote }}</el-text>
      </el-form-item>
      <el-form-item label="仓储">
        <el-select v-model="data.storagePay.storage" filterable :disabled="data.storagePay.id != null">
          <el-option v-for='storageItem in show.storageList' :key="storageItem.id" :label="storageItem.value" :value="storageItem.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="申请日期">
        <el-date-picker style="width: 100%;" v-model="data.storagePay.applyDate" type="date" :disabled="data.storagePay.id != null" />
      </el-form-item>
      <el-form-item label="用途">
        <el-select v-model="data.storagePay.useto" filterable :disabled="data.storagePay.id != null">
          <el-option v-for='paymentUsetoItem in show.paymentUsetoList' :key="paymentUsetoItem.id" :label="paymentUsetoItem.value" :value="paymentUsetoItem.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="金额">
        <el-input-number style="width: 100%;" :controls="false" :precision="2" v-model="data.storagePay.amount" :disabled="data.storagePay.id != null" />
      </el-form-item>
      <el-form-item label="打款回单" v-if="data.storagePay.id != null && data.storagePay.reviewState == 'pass'">
        <el-upload style="width: 100%;" v-model:file-list="data.file.paymentReceipt" :action="api.baseURL() + '/backend/file/upload'" :headers="api.tokenHeader()" multiple drag :on-error="() => ElMessage.error('上传失败')" :limit="10" :on-preview="(f) => util.previewElfile(f)">
          <el-text>点击或拖转到此处上传文件</el-text>
        </el-upload>
      </el-form-item>
      <el-form-item label="发票" v-if="data.storagePay.id != null && data.storagePay.reviewState == 'pass'">
        <el-upload style="width: 100%;" v-model:file-list="data.file.invoice" :action="api.baseURL() + '/backend/file/upload'" :headers="api.tokenHeader()" multiple drag :on-error="() => ElMessage.error('上传失败')" :limit="10" :on-preview="(f) => util.previewElfile(f)">
          <el-text>点击或拖转到此处上传文件</el-text>
        </el-upload>
      </el-form-item>
    </el-form>
  </div>
</template>

<script setup>
import { reactive, } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'

const router = useRouter()
const show = reactive({
  storageList: [],
  paymentUsetoList: [],
})
const pageParam = cache.getObject(cache.keys.pageParam + "storagePayDetail")
const data = reactive({
  storagePay: pageParam ? JSON.parse(JSON.stringify(pageParam)) : {},
  file: {}
})

data.file.paymentReceipt = util.json2Elfile(data.storagePay.paymentReceipt)
data.file.invoice = util.json2Elfile(data.storagePay.invoice)

api.get('/backend/dict/getByCode', { params: { code: 'storage' } }).then(res => {
  show.storageList = res.dictList
})
api.get('/backend/dict/getByCode', { params: { code: 'paymentUseto' } }).then(res => {
  show.paymentUsetoList = res.dictList
})

const add = () => {
  const param = JSON.parse(JSON.stringify(data.storagePay))
  param.applyDate = util.parseTime(param.applyDate, '{y}-{m}-{d}')
  api.post('/backend/storagePay/add', param).then(() => {
    ElMessage.success('保存成功')
    router.go(-1)
  })
}

const payment = () => {
  const param = { id: data.storagePay.id }
  param.paymentReceipt = util.elfile2Json(data.file.paymentReceipt)
  param.invoice = util.elfile2Json(data.file.invoice)
  api.post('/backend/storagePay/payment', param).then(() => {
    ElMessage.success('保存成功')
    router.go(-1)
  })
}

</script>

<style lang="less">
.storagePayDetail {
  margin: auto;
  max-width: 900px;
}
</style>